module.exports = __webpack_public_path__ + "img/Minhal_cologe.390c57dc.svg";